import { useEffect, useRef, useState } from 'react'
import { Address } from '../runtimeComponent/subComponent/AddressSearchComponent';
import axios from 'axios';
import { getEnvVar } from '../config/RuntimeConfig';
import {
    getMockAddressSearchResponse,
    getMockPostalLookupResponse,
    isE2EBypassEnabled,
} from '../utilities/E2EBypassUtils';


export interface AddressSearchResponse { 
    mailAddressChoice: {
        addressDetails?: Address;
        addressAlternatives?: string[];
    } | Address[];
    status: string;
}

interface AddressSearchRequest {
    addressString: string;
    displayAddressLines: boolean;
    optionSelected: string;
    province: string;
    hideProvince?: boolean;
}

export const useAddressSearch  = (address: string, searchUrl: string, isNoStreetNoAddress=false, ignorSearch=false, accessToken?: string,  field?: { CanadianAddress: boolean }, hideCountry?: boolean ): {
    data: any; // AddressSearchResponse,
    setSearchingAddress: (arg: string) => void;
    loading: boolean;
    error: any;

} => {
    const [data, setData] = useState<AddressSearchResponse>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string|undefined>();
    const [searchingAddress, setSearchingAddress] = useState(address);

    const firstCallRef = useRef(true);

    useEffect(() => {
        const doSearch = async () => {
            try {
                const request:AddressSearchRequest = {
                    addressString: searchingAddress,
                    displayAddressLines: true,
                    optionSelected: '',
                    province: field?.CanadianAddress ? null : "ON",
                    hideProvince: field?.CanadianAddress === true
                };
                const headers = { "Content-Type": "application/json" };
                if (accessToken) {
                    headers['Authorization'] = `Bearer ${accessToken}`;
                };
                if (!isNoStreetNoAddress) {
                    const result = isE2EBypassEnabled()
                        ? { data: getMockAddressSearchResponse(searchingAddress) }
                        : await axios.post(searchUrl, request, {headers});
                    if (/OK/i.test(result.data?.status)) {
                        if(result.data.mailAddressChoice?.addressDetails && !result.data.mailAddressChoice?.addressDetails.country && !hideCountry){
                            result.data.mailAddressChoice.addressDetails.country='Canada'
                        }
                        setData(result.data);
                    } else {
                        setError(result.data?.errMsg || 'Address Search Failed');
                    }
                } else {
                    const postalCode = searchingAddress?.trim();
                    if (!(/^[a-z][0-9][a-z]\s*[0-9][a-z][0-9]$/i).test(postalCode)) {
                        setError(undefined);
                        return;
                    }
                    const result = isE2EBypassEnabled()
                        ? { data: getMockPostalLookupResponse(postalCode) }
                        : await axios.post(getEnvVar('POSTAL_CODE_LOOKUP_URL'), {postalCode}, {headers});
                    if (/OK/i.test(result.data?.status)) {
                        setData(result.data);
                    } else {
                        setError(result.data?.errMsg || 'postal code search failed');
                    }
                }
            } catch (err) {
                console.error(`search address failed: ${err.message}`);
                setError(err);
            }finally {
                setLoading(false);
            }
        };


        if (!searchingAddress || ignorSearch) {                                                                                                                        
            setLoading(false);
            return () => {};   
        }
        setLoading(true);
        if (firstCallRef.current) {
            doSearch();
            firstCallRef.current = false;
            return () => {};  
        } else {
            const timeoutId = setTimeout(() => {
                doSearch();
            }, 500);
            return () =>clearTimeout(timeoutId);
        }
        
    }, [searchingAddress]);

    return { data, loading, error, setSearchingAddress };
};
